import { render, staticRenderFns } from "./TaskTabs.vue?vue&type=template&id=364dbd2e&"
import script from "./TaskTabs.vue?vue&type=script&lang=js&"
export * from "./TaskTabs.vue?vue&type=script&lang=js&"
import style0 from "./TaskTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports